import { render, staticRenderFns } from "./groupDetails.vue?vue&type=template&id=247a438c&"
import script from "./groupDetails.vue?vue&type=script&lang=js&"
export * from "./groupDetails.vue?vue&type=script&lang=js&"
import style0 from "./groupDetails.vue?vue&type=style&index=0&id=247a438c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports